import { connect } from 'react-redux';
import EditTransactions, {
  Props,
} from '@/components/DeprecatedPortfolio/components/Legacy/EditTransactions';
import {
  fetchPortfolioList,
  handleIFrameRedirectToPortfolio,
} from '@/components/DeprecatedPortfolio/redux/actions';
import { SWS_LEGACY_HOST } from '@/constants';

type StateProps = Pick<Props, 'url' | 'portfolioId'>;
const mapStateToProps = (state): StateProps => {
  const {
    payload: { id },
  } = state.location;

  return {
    url: `${SWS_LEGACY_HOST}/user/portfolio/portal/edit/`,
    portfolioId: id,
  };
};

type DispatchProps = Pick<
  Props,
  'handleFetchPortfolioList' | 'handleIFrameRouteChangingEvent'
>;
const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    handleFetchPortfolioList: () => dispatch(fetchPortfolioList()),
    handleIFrameRouteChangingEvent: (data) =>
      dispatch(handleIFrameRedirectToPortfolio(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTransactions);
